import React from "react";
import Accordion from "react-bootstrap/Accordion";
import check_icon from "../../../assets/10_POSVENTA/05_mantenimiento/icon-check.svg";
import { Table } from "react-bootstrap";
/*eslint-disable */

interface AcordeonComponentProps {
  datos: any;
  activeComparador: any;
}
declare const window: any;
const AcordeonComponent: React.FC<AcordeonComponentProps> = ({
  datos,
  activeComparador,
}) => {
  return (
    <div
      className={`accordion-comparador-component ${
        activeComparador ? "active" : ""
      }`}
    >
      <Accordion defaultActiveKey="0">
        {datos?.map((item: any, index: number) => (
          <Accordion.Item key={index} eventKey={`${index}`}>
            <Accordion.Header>{item?.title}</Accordion.Header>
            <Accordion.Body>
              <Table striped bordered hover>
                <tbody>
                  {item?.content.map((e: any, idx: number) =>
                    e.label ? (
                      <tr key={idx}>
                        <td style={{ width: "33.33%" }}>{e.label}</td>
                        <td style={{ width: "33.33%", textAlign: "center" }}>
                          {e.firts === "Yes" ? (
                            <img src={check_icon} alt="Check icon" />
                          ) : (
                            e.firts
                          )}
                        </td>
                        <td style={{ width: "33.33%", textAlign: "center" }}>
                          {e.second === "Yes" ? (
                            <img src={check_icon} alt="Check icon" />
                          ) : (
                            e.second
                          )}
                        </td>
                      </tr>
                    ) : null
                  )}
                </tbody>
              </Table>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
};

export default AcordeonComponent;
